import React from "react";
import { Link } from "react-router-dom";
import ErrorMessage from "../../../feature-module/components/errorMessage";
import InputField from "../../../feature-module/components/InputField";
import useCreateSalesReturn from "../../../feature-module/sales/useCreateSalesReturn";
import ImageWithBasePath from "../../img/imagewithbasebath";

const AddSalesReturns = (props) => {

  const { values, functions } = useCreateSalesReturn(props)

  return (
    <div>
      {/* add popup */}
      <div className="modal fade" id="add-sales-new">
        <div className="modal-dialog add-centered">
          <div className="modal-content">
            <div className="page-wrapper p-0 m-0">
              <div className="content p-0">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4> Add Sales Return</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="table-responsive no-pagination">
                        <table className="table  datanew">
                          <thead>
                            <tr>
                              <th className="p-4">S. No</th>
                              <th className="p-4">Product</th>
                              <th className="p-4">Qty</th>
                              <th className="p-4">Returned Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              values?.data?.map((item, index) => (
                                <tr key={item.id}>
                                  <td className="p-4">{index + 1}</td>
                                  <td className="p-4">
                                    <div className="productimgname">
                                      <div className="product-img stock-img">
                                        <ImageWithBasePath
                                          alt=""
                                          src={
                                            item?.product?.images?.length > 0
                                              ? item?.product?.images
                                              : "assets/img/product/noimage.png"
                                          }
                                          isApiImage={
                                            item?.product?.images?.length > 0
                                              ? true
                                              : false
                                          }
                                        />
                                      </div>
                                      {item?.product?.name}
                                    </div>
                                  </td>
                                  <td className="p-4">
                                    {item?.quantity}
                                  </td>
                                  <td className="p-4">
                                    <InputField
                                      type="number"
                                      value={values.returns.find(i => i.sale_item_id == item.id)?.quantity}
                                      onChange={(e) => functions.onChangeQuantity(e?.target?.value, index)}
                                      className="product-quantity quntity-input no-spinner"
                                      style={{
                                        width: "75%",
                                        textAlign: "center",
                                      }}
                                    />
                                    {console.log("Return Errors", item.id, values.errors)}
                                    <ErrorMessage error={values.errors[item.id] ? `Quantity ≤ ${item?.quantity}` : null} />
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 ms-auto">
                          <div className="total-order w-100 max-widthauto m-auto mb-4">
                            <ul>
                              <li>
                                <h4>Order Tax</h4>
                                <h5>$ 0.00</h5>
                              </li>
                              <li>
                                <h4>Discount</h4>
                                <h5>$ 0.00</h5>
                              </li>
                              <li>
                                <h4>Shipping</h4>
                                <h5>$ 0.00</h5>
                              </li>
                              <li>
                                <h4>Grand Total</h4>
                                <h5>$ 0.00</h5>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-sm-12 col-12">
                          <div className="input-blocks mb-5">
                            <InputField type="textarea" label="Reason" placeholder="Write Reason" />
                          </div>
                        </div>
                        {/* <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks mb-5">
                            <label>Status</label>
                            <Select
                              classNamePrefix="react-select"
                              options={status}
                              placeholder="Choose"
                            />
                          </div>
                        </div> */}
                        <div className="col-lg-12 text-end">
                          <button
                            type="button"
                            className="btn btn-cancel add-cancel me-3"
                            data-bs-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <Link className="btn btn-submit add-sale" onClick={functions.onSubmit}>
                            Submit
                          </Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSalesReturns;
